export const INITIAL_DATA = 'InitialData';
export const MANUAL_INPUT = 'ManualInput';
export const CURRENT_BALANCE = 'CURRENT_BALANCE';

export const DISCONNECTED = 'DISCONNECTED';
export const PLAYER_NR_TABLE_LIMIT_REACHED = 'PLAYER_NR_TABLE_LIMIT_REACHED';
export const GAME_RESULT = 'GAME_RESULT';
export const LAST_BETS = 'LAST_BETS';
export const LOADING = 'LOADING';
export const NO_MORE_BETS = 'NO_MORE_BETS';
export const INSURANCE_NO_MORE_BETS = 'INSURANCE_NO_MORE_BETS';
export const PLACE_YOUR_BETS = 'PLACE_YOUR_BETS';
export const DYNAMIC_MULTIPLIERS = 'DynamicMultipliers';
export const RECONNECTING = 'RECONNECTING';
export const TABLE_CLOSED = 'TABLE_CLOSED';
export const WAIT_FOR_NEXT_ROUND = 'WAIT_FOR_NEXT_ROUND';
export const WAIT_FOR_NEXT_GAME = 'WAIT_FOR_NEXT_GAME';
export const SKIP_PYB_TIMER = 'SkipPYBTimer';
export const PLACE_BET_INTENT_POOL = 'PlaceBetIntentPool';
export const REVEAL_CARDS = 'RevealCards';
export const SORTED_CARDS = 'SortedCards';
export const TIE = 'Tie';
export const WAIT_FOR_RESULTS = 'WAIT_FOR_RESULTS';
export const MULTIPLIER = 'Multiplier';

export const SHUFFLE = 'SHUFFLE';
export const ERROR = 'Error';
export const FATAL_ERROR = 'FATAL_ERROR';
export const CANCEL_ROUND = 'CANCEL_ROUND';
export const CLEAR_ALL_CARDS = 'CLEAR_ALL_CARDS';
export const INCIDENT_OPEN = 'INCIDENT_OPEN';
export const INCIDENT_CLOSED = 'INCIDENT_CLOSED';
export const TABLE_CANCELLED = 'TableCancelled';
export const BLOCKED_PLAYER = 'BlockedPlayer';
export const OPERATOR_ERROR = 'OperatorError';
export const BET_NOT_PLACED = 'BetNotPlaced';
export const TIP_NOT_PLACED = 'TipNotPlaced';

export const BET_BEHIND_RESULTS = 'BetBehindResult';
export const SEAT_RESULT = 'SeatResult';
export const FIRST_CARD_HANDS = 'FirstCardHands';
export const CALL_BETS = 'CallBets';
export const CALL_BETS_DECISION = 'CallBetDecision';
export const FIRST_DECISION_CALL = 'FirstDecisionCall';
export const SECOND_DECISION_CALL = 'SecondDecisionCall';
export const THIRD_DECISION_CALL = 'ThirdDecisionCall';
export const CALL_FIRST_DECISION = 'CallFirstDecision';
export const CALL_SECOND_DECISION = 'CallSecondDecision';
export const CALL_THIRD_DECISION = 'CallThirdDecision';
export const CALL_DECISION = 'CallDecision';
export const PLAYER_TURN = 'PlayerTurn';
export const INSURANCE_CALLS = 'InsuranceCalls';
export const INSURANCE_DECISION = 'InsuranceDecision';
export const CARD_MESSAGE = 'CardMessage';
export const PLAYERS_BETS = 'PlayersBets';
export const CARD = 'Card';
export const WINNING_BALL = 'WinningBall';
export const WINNING_BALLS = 'WinningBalls';
export const CANCEL_LAST_CARD = 'CancelLastCard';
export const WON_BETS = 'WonBets';
export const SPLIT_CARDS = 'SplitCards';
export const NO_SPIN = 'NoSpin';
export const VIDEO_MODERATION_RESULT = 'VideoModerationResult';

export const UPDATED_LOBBY_DATA = 'UPDATED_LOBBY_DATA';
export const UPDATED_TABLE_HISTORY = 'UPDATED_TABLE_HISTORY';
export const UPDATE_FREE_SEATS = 'UPDATE_FREE_SEATS';
export const TABLE_OCCUPANCY = 'TABLE_OCCUPANCY';
export const INITIALIZE_TABLE = 'INITIALIZE_TABLE';
export const CANCEL_TABLE = 'CANCEL_TABLE';
export const RESERVE_SEAT = 'ReserveSeat';
export const PLAYERS_NUMBER = 'PlayersNumber';

export const NETWORK_DISCONNECT = 'NetworkDisconnect';
export const SERVER_DISCONNECTED_INACTIVITY = 'DisconnectedForInactivity';
export const DISCONNECTED_SESSION = 'DisconnectedSession';
export const RECONNECT_TO_SERVER = 'RECONNECT_TO_SERVER';

export const NO_SPIN_REASON_LOW_BALL_SPIN_COUNT = 'LowBallSpinCount';
export const NO_SPIN_REASON_ROTOR_AND_BALL_SAME_DIRECTION = 'RotorAndBallSameDirection';
export const NO_SPIN_REASON_UNKNOWN_OBJECT_IN_THE_WHEEL = 'UnknownObjectInRim';
export const NO_SPIN_REASON_BALL_NOT_IN_THE_WHEEL = 'UnknownObjectInRim';
export const NO_SPIN_REASON_UNKNOWN = 'Unknown';

// Regulations
export const PLAYER_LIMITS_NOTIFICATION = 'PlayerLimitsNotification';
export const REALITY_CHECK = 'RealityCheck';
export const SESSION_LIMIT = 'SessionLimit';
export const WAGER_LIMIT = 'WagerLimit';
export const LOSS_LIMIT = 'LossLimit';
export const STAKE_LIMIT = 'StakeLimit'; // used only for OSS
export const SESSION_DELAYED_LIMIT = 'SessionDelayedLimit';
export const MAXIMUM_CREDIT_LIMIT = 'WagerSoftLimit';
export const DISCONNECTED_FROM_OPERATOR = 'DisconnectedFromOperator';
export const NET_POSITION = 'NET_POSITION';

// LOTTERY
export const RESULTS_OVER = 'ResultsOver';

// Marble Race Game
export const RACE_START_TIMER = 'RaceCountdown';

// Matka
export const SPIN_BOWL = 'SpinBowl';
export const SELECT_BALLS = 'SelectBalls';

// Bonus
export const BonusMessage = {
  BonusWheelStart: 'bonusWheelStart',
  BonusWheelCancelled: 'bonusWheelCancelled',
  BonusWheelAccepted: 'bonusWheelAccepted',
  BonusWheelFinished: 'bonusWheelFinished',
  BonusWheelOperatorError: 'bonusWheelOperatorError',
};
